import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import CountUp from "react-countup";
import { STATS } from "../lib/content";

export default function StatsCounter() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      data-testid="stats-counter"
      className="relative bg-white border-y border-black/8"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-black/8">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            className="py-12 md:py-20 px-4 md:px-8 text-center md:text-left"
          >
            <div className="font-display text-5xl md:text-6xl text-[#0A0A0A] tracking-tight">
              {inView ? (
                <CountUp
                  end={s.value}
                  duration={2.4}
                  decimals={s.decimals || 0}
                  separator=","
                  suffix={s.suffix || ""}
                />
              ) : (
                "0"
              )}
            </div>
            <p className="mt-3 text-[12px] uppercase tracking-[0.22em] text-[#525252]">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
